import tw from 'tailwind-styled-components'

export const StatItemWrapper = tw.div`
  flex flex-col gap-10 overflow-hidden
`
export const StatItemHeading = tw.div`
    flex items-center gap-x-4 md:gap-x-8
`

export const ProgressBar = tw.div`
    block h-2 rounded-3 bg-borderGray relative
`

export const Progress = tw.div`
    absolute top-0 left-0 h-full w-full rounded-3 bg-eucalyptus 
`

export const Heading4 = tw.h4`
  text-darkGrey font-medium leading-4 text-2xs md:text-xs whitespace-nowrap overflow-hidden overflow-ellipsis
`

export const Heading5 = tw.h5`
  text-white font-semibold leading-none tracking-tight text-md md:text-lg lg:text-xl
`